<template>
  <div>
    <v-card class="main white--text mt-10" style="border-radius: 30px;">
      <v-card-text class="white--text">
        <v-row justify="center" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
        <v-col align="start">
          <h2> {{ booking.capturedAddress }} </h2>
        </v-col>
        <v-col align="end">
            <h2 class="info--text" > Booking {{ booking.orderNumber.number }} </h2>
        </v-col>
      </v-row>
    </v-card-text>    
      <!--Shows all drivers's location within a specific client's area, when booking is still pending-->
      <GmapMap
          v-if="this.booking.status.status == 'SCHEDULING'"
          :center="position"
          :zoom="8.5"
          class="map"
          :options="{
            mapTypeControl: false,
            streetViewControl: false,
            disableDefaultUI: true
          }"
          style="width: 100%; height: 230px"
      >
        <GmapMarker 
        v-for="(p, index) in getLocations"
        :key="index"
        :position="p" 
        :icon="'https://www.wrapp.co.za/img/truck_pin.png'" 
        />
      </GmapMap>

      <!--Shows a particular driver's location who scheduled a booking-->
      <GmapMap
          v-if="this.booking.status.status == 'SCHEDULED'"
          :center="position"
          :zoom="18"
          class="map"
          :options="{
            mapTypeControl: false,
            streetViewControl: false,
            disableDefaultUI: true
          }"
          style="width: 100%; height: 230px"
      >
        <GmapMarker 
        :position="position" 
        :icon="'https://www.wrapp.co.za/img/truck_pin.png'" 
        />
      </GmapMap>
    </v-card>
  </div>
</template>

<script>

import { gmapApi } from 'vue2-google-maps';
import GmapMarker from 'vue2-google-maps/src/components/marker';
export default {
  name: 'trackBookings',
  computed: {
    google: gmapApi,
    user() {
      return this.$store.getters['auth/getUser'];
    },
    getLocations(){
      return this.$store.getters['driver/getLocations'];
    },
    getPositions(){
      return this.$store.getters['driver/getPositions'];
    }
  },
  components: {
    GmapMarker,
  },
  props: {
    booking: Object,
    position: Object
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$store.dispatch('driver/getDriverLocations', this.booking.id);
  }
};
</script>

<style lang="scss" scoped>

</style>